import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import transcriptSpeakerMergeFailed, {
	type TranscriptSpeakerMergeFailedAction,
} from '@Application/Beneficiaries/Transcripts/Actions/transcriptSpeakerMergeFailed';
import type { TranscriptSpeakerPayload } from '@Application/Beneficiaries/Transcripts/Actions/transcriptSpeakersFetched';
import transcriptSpeakersMerged, {
	type TranscriptSpeakersMergedAction,
} from '@Application/Beneficiaries/Transcripts/Actions/transcriptSpeakersMerged';
import type MergeTranscriptSpeakers from '@Application/Beneficiaries/Transcripts/Commands/MergeTranscriptSpeakers';
import { post } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = TranscriptSpeakersMergedAction | TranscriptSpeakerMergeFailedAction;

export default (command: MergeTranscriptSpeakers) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<TranscriptSpeakerPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/interviews/${command.interviewId}/transcript/speakers/${command.speakerId}/merges`,
				command.toJSON(),
			);

			const action = transcriptSpeakersMerged(payload, command.interviewId, command.speakerId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = transcriptSpeakerMergeFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
